// extracted by mini-css-extract-plugin
module.exports = {"wrp":"TitleBanner_wrp__QrKyv","innerWrp":"TitleBanner_innerWrp__TkmQB","text":"TitleBanner_text__lmMvm"};